export const productToForm = () => {
  const productButtons = document.querySelectorAll(
    ".industrial-waste .product__btn, .construction-waste .product__btn",
  );
  const formSection = document.querySelector("#formularz-wyceny");

  if (!productButtons.length || !formSection) {
    return;
  }

  const normalizeText = (value) =>
    String(value || "")
      .trim()
      .toLowerCase();

  const getMappedValue = (title) => {
    const normalizedTitle = normalizeText(title);
	console.log(normalizedTitle);
	
    if (normalizedTitle.includes("big bag")) {
      return "Big Bag";
    }

    if (normalizedTitle.includes("kontener")) {
      return "Kontener";
    }
 if (normalizedTitle.includes("pojemniki na mniejsze odpady")) {
      return "Pojemnik na mniejsze odpady";
    }
    if (normalizedTitle.includes("pojemniki")) {
      return "Pojemnik 1100l";
    }
    if (normalizedTitle.includes("prasokontener")) {
      return "Prasokontener";
    }
   
    if (normalizedTitle.includes("samochód z windą")) {
      return "Samochód z windą";
    }

    return null;
  };

  const findMatchingOptionButton = (expectedLabel) => {
    const normalizedExpectedLabel = normalizeText(expectedLabel);

    return Array.from(
      formSection.querySelectorAll(".custom-select__option"),
    ).find((optionButton) => {
      const optionLabel = normalizeText(optionButton.textContent);
      const optionValue = normalizeText(optionButton.dataset.value);

      if (normalizedExpectedLabel === "big bag") {
        return (
          optionButton.dataset.placeholder === "true" &&
          optionLabel === "big bag"
        );
      }

      return (
        optionLabel === normalizedExpectedLabel ||
        optionValue === normalizedExpectedLabel
      );
    });
  };

  const triggerOptionSelection = (label) => {
    const optionButton = findMatchingOptionButton(label);

    if (!optionButton) {
      return false;
    }

    optionButton.click();
    return true;
  };

  const scrollToForm = () => {
    formSection.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  productButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();

      const product = button.closest(".product");
      const title =
        product?.querySelector(".product__title")?.textContent || "";
      const mappedValue = getMappedValue(title);

      scrollToForm();

      if (!mappedValue) {
        return;
      }

      window.setTimeout(() => {
        triggerOptionSelection(mappedValue);
      }, 450);
    });
  });
};
